export { StaticTimePicker } from './StaticTimePicker';
export type {
  StaticTimePickerProps,
  StaticTimePickerSlots,
  StaticTimePickerSlotProps,
} from './StaticTimePicker.types';
